import { ApiDOMError } from '@swagger-api/apidom-error';

/**
 * @public
 */
class ParseError extends ApiDOMError {}
export default ParseError;